var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Button } from '@bfa/base-ui';
import { useClientConfiguration } from '@bfa/nextjs-common/hooks';
import React from 'react';
import { AnalyticsLink } from '../../../../../../components/Analytics';
import { SUBSCRIBED_LANDING_PAGE_EVENTS as EVENTS } from '../../../../../../utils/analytics/events';
import { StyledDivider, StyledPanelContainer, StyledPanelTextContainer, } from './SubscribedPanel.styled';
import SubscribedPanelText from './SubscribedPanelText';
import SubscribedPanelTitle from './SubscribedPanelTitle';
var SubscribedPanel = function (_a) {
    var slide = _a.slide;
    var client = useClientConfiguration();
    var isMobile = client.isMobile();
    var mobileTitle = slide.mobileTitle, desktopTitle = slide.desktopTitle, mobileText = slide.mobileText, desktopText = slide.desktopText, buttonLink = slide.buttonLink, buttonText = slide.buttonText;
    return (React.createElement(StyledPanelContainer, null,
        React.createElement(StyledPanelTextContainer, null,
            React.createElement(SubscribedPanelTitle, { mobile: mobileTitle, desktop: desktopTitle }),
            React.createElement(StyledDivider, { small: true }),
            React.createElement(SubscribedPanelText, { mobile: mobileText, desktop: desktopText })),
        React.createElement(React.Fragment, null, buttonLink && buttonText && (React.createElement(AnalyticsLink, { eventData: __assign(__assign({}, EVENTS.CLICK_ON_CAROUSEL_SLIDE_BUTTON), { label: "Clicked ".concat(buttonText, " Button from Banner") }), href: buttonLink, passHref: true },
            React.createElement(Button, { variant: "primary", small: isMobile, "data-testid": "subscribed-panel-cta-button" }, buttonText))))));
};
export default SubscribedPanel;
